// types
import { Account, Entity, Loan } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Typography } from '@mui/material';

// ui
import { IconCircleLoan } from '../../../ui/IconCircleLoan/IconCircleLoan';
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// links
import { LinkEntity } from '../../../links/LinkEntity/LinkEntity';

// props
export interface EntityFinancing {
	idWbg: string | null;
	accounts: Account[];
	parent: Entity | null;
}
export interface TableBasicFinancingProps extends Omit<TableProps, 'headers'> {
	data: EntityFinancing[];
}

export const TableBasicFinancing = ({ data = [], ...props }: TableBasicFinancingProps) => {
	// hooks
	const { t } = useTranslation();

	const headers = [
		{
			label: t('source'),
			value: 'code',
			render: (code: string, header: TableHeader, loan: Loan) => {
				return (
					<Grid alignItems="center" container spacing={1}>
						<Grid item>
							<IconCircleLoan loan={loan} size="xs" />
						</Grid>
						<Grid item>
							<Typography fontWeight={600}>{code}</Typography>
						</Grid>
					</Grid>
				);
			},
		},
		{
			label: t('parentEntity'),
			value: 'parent',
			render: (parentEntity: Entity) => {
				return <LinkEntity entity={parentEntity} />;
			},
		},
		{
			label: t('accounts'),
			value: 'accounts',
			render: (accounts: Account[]) => {
				return accounts.map((account: Account) => account.name).join(', ');
			},
		},
	];
	return <Table {...props} data={data} headers={headers} />;
};
